import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { StoresApi } from "apis/StoresApi";
import { Store, StoreExtended } from "models/dbModels/stores/Store";
import { StoreSearchFilterQuery } from "models/filters/stores/StoreSearchFilterQuery";

export const getStores = createAsyncThunk("storesSlice/getStores", async (params: StoreSearchFilterQuery) => {
    const response = await StoresApi.Search(params);
    return response.data;
});

export const getStoreById = createAsyncThunk("storesSlice/getStoreById", async (id: number) => {
    const response = await StoresApi.Search({ ids: [id] });
    return response.data;
});

export const updateStoreDetails = createAsyncThunk("storesSlice/updateStoreDetails", async (store: Store) => {
    const response = await StoresApi.Update([store]);
    return response.data;
});

export const createStore = createAsyncThunk("storesSlice/createStore", async (store: Store) => {
    store = {...store, status: "Active"};
    const response = await StoresApi.Add([store]);
    return response.data;
});

type InitialStateType = {
    connected: boolean;
    id: number;
    ownerId: number;
    name: string;
    username: string;
    passwordHash: string;
    storeGroupId: string;
    defaultStoreGroupId: string;
    status: string;
    password: string;
    lastRunningVersion: string;
    confirmPassword: string;
    setNewPassword: boolean;
    loading: boolean;
    readyToSave: boolean;
    selectedRows: any[];
    deselectedRows: any[];
    selectAllFilter: boolean;
    keyword: string;
    totalRows: number;
    totalPages: number;
    pageIndex: number;
    pageSize: number;
    error: string;
    table: StoreExtended[];
    loadingTable: boolean;
};

const initialState : InitialStateType = {
    connected: false,
    id: 0,
    ownerId: 0,
    name: "",
    username: "",
    passwordHash: "",
    storeGroupId: "",
    defaultStoreGroupId: "",
    status: "",
    password: "",
    lastRunningVersion: "",
    confirmPassword: "",
    setNewPassword: false,
    loading: false,
    readyToSave: true,
    selectedRows: [],
    deselectedRows: [],
    selectAllFilter: false,
    keyword: "",
    totalRows: 0,
    totalPages: 0,
    pageIndex: 0,
    pageSize: 100,
    error: "",
    table: [],
    loadingTable: false,
}

const storesTablesSlice = createSlice({
    name: "storesSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        updateStoreField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        cleanStoreDetails: (state) => {
            return {
                ...state,
                ...initialState
            };
        },
        addSelectedRows: (state, action) => {
            
            // @ts-ignore
            state.selectedRows[action.payload.index] = action.payload.rows;
        },
        addDeselectedRows: (state, action) => {
            // @ts-ignore
            state.deselectedRows[action.payload.index] = action.payload.rows;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getStores.pending, (state) => {
            state.loading = true;
            state.table = [];
            state.error = "";
        });
        builder.addCase(getStores.fulfilled, (state, action) => {
            state.table = action.payload.data ? action.payload.data : [];
            state.totalRows = action.payload.totalRows;
            state.totalPages = Math.ceil(Math.ceil(action.payload.totalRows) / state.pageSize);
            state.loading = false;
        });
        builder.addCase(getStores.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || "";
        });
        builder.addCase(getStoreById.fulfilled, (state, action) => {
            const store = action.payload.data[0];
            state.connected = store.connected;
            state.id = store.id;
            state.ownerId = store.ownerId;
            state.name = store.name;
            state.username = store.username;
            state.status = store.status;
            state.password = "";
            state.confirmPassword = "";
            state.loading = false;
            state.lastRunningVersion = store.lastRunningVersion;
        });
    },
});

export const { addDeselectedRows, addSelectedRows, cleanStoreDetails, updateStoreField } = storesTablesSlice.actions;

export default storesTablesSlice.reducer;